import { GoogleOAuthProvider } from '@react-oauth/google';
import 'mathlive/fonts.css';
import React, { useEffect, useState } from 'react';
import RNBootSplash from 'react-native-bootsplash';
import config from 'react-native-ultimate-config';
import RootView from './WebRootView';
import { WebRNModuleAPIs } from './components/15-containers/SuperChargedWebView/communication/web2RNCom/WebRNModuleAPIs';
import useAppInit from './hooks/app-level/useAppInit';
import { isWebView } from './utils/platform';
import setupBaseStyle from './web/baseStyle';
import initFirebase from './web/firebase';
import installServiceWorker from './web/installServiceWorker';
import initSentry from './web/sentry';
import initSyncStorage from './web/syncStorage';
initFirebase();
initSentry();
setupBaseStyle();
initSyncStorage();
installServiceWorker();
const App = () => {
    const [appInitialized] = useAppInit();
    const [navigationReady, setNavigationReady] = useState(false);
    useEffect(() => {
        if (appInitialized && navigationReady) {
            if (isWebView) {
                WebRNModuleAPIs.WVLifeCycle.loaded();
            }
            else {
                RNBootSplash.hide({ fade: true });
            }
        }
    }, [appInitialized, navigationReady]);
    return (React.createElement(GoogleOAuthProvider, { clientId: config.GOOGLE_OAUTH_WEB_CLIENT_ID },
        React.createElement(RootView, { onNavigationReady: () => setNavigationReady(true) })));
};
export default App;
